const valToLowercase = () => {

  $('#confirm-email-address').on('keyup', function(){
    var string = $('#confirm-email-address').val();
    //console.log(string);
    if(/[A-Z]/.test(string)){
        var z = $('#confirm-email-address').val().toLowerCase();
        var value = $('#confirm-email-address').val(z);
    }
  });
};

export {valToLowercase}
